import CircularProgress from "@mui/material/CircularProgress";

const CustomLoadingOverlay = () => {
  return <CircularProgress />;
};

export default CustomLoadingOverlay;
